import { render, staticRenderFns } from "./AuthorizationLayout.vue?vue&type=template&id=c32f97e8&scoped=true"
var script = {}
import style0 from "./AuthorizationLayout.vue?vue&type=style&index=0&id=c32f97e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32f97e8",
  null
  
)

export default component.exports